import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ISelectedBrandModel {
    brandId: string;
    modelId: string;
    modelName: string;
}

@Injectable({
    providedIn: 'root'
})
export class SelectedBrandModelService {
    private storageKey = 'selected_brand_model';
    private selection$ = new BehaviorSubject<ISelectedBrandModel | null>(this.readFromStorage());

    readonly value$ = this.selection$.asObservable();

    private readFromStorage(): ISelectedBrandModel | null {
        if (typeof localStorage === 'undefined') return null;
        try {
            return JSON.parse(localStorage.getItem(this.storageKey) || 'null');
        } catch {
            return null;
        }
    }

    get(): ISelectedBrandModel | null {
        return this.selection$.value;
    }

    set(selection: ISelectedBrandModel) {
        this.selection$.next(selection);
        if (typeof localStorage !== 'undefined') localStorage.setItem(this.storageKey, JSON.stringify(selection));
    }

    clear() {
        this.selection$.next(null);
        if (typeof localStorage !== 'undefined') localStorage.removeItem(this.storageKey);
    }
}
